import Game from "./game";
export default Game;